import { render, staticRenderFns } from "./create-help.vue?vue&type=template&id=119a4f67"
import script from "./create-help.vue?vue&type=script&lang=js"
export * from "./create-help.vue?vue&type=script&lang=js"
import style0 from "./create-help.vue?vue&type=style&index=0&id=119a4f67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports